import React, { FunctionComponent, useState } from 'react';
import Styles from 'components/dateFormat/DateFormat.module.scss';
import ModalShell from 'components/chatModal/ChatModalShell.module.scss';
import RadioButton from 'components/button/radioButton/RadioButton';
import { date } from 'helpers/data/dateAndTime';

interface DateFormatProps {
  handleClose: Function;
  selectedValue?: string;
}

const DateFormat: FunctionComponent<DateFormatProps> = (props: DateFormatProps) => {
  const { handleClose, selectedValue = '' } = props;
  const [value, setValue] = useState(selectedValue);
  const handleDone = () => handleClose(value || selectedValue);
  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    setValue(event.currentTarget.value);
  };

  return (
    <>
      <div className={Styles.optionsList}>
        {date.map((d) => (
          <div
            className={Styles.optionRow}
            key={d.value}
            onClick={() => setValue(d.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setValue(d.value);
              }
            }}
            role="button"
            tabIndex={0}
          >
            <div className={Styles.optionText}>
              <p className={Styles.optionTitle}>{d.format}</p>
              <span className={Styles.optionDetail}>{d.eg}</span>
            </div>
            <RadioButton
              name="date_format"
              value={d.value}
              checked={value === d.value}
              handleChange={handleChange}
            />
          </div>
        ))}
      </div>
      <div className={ModalShell.footer}>
        <button type="button" className={Styles.doneBtn} onClick={handleDone}>
          Done
        </button>
      </div>
    </>
  );
};

export default DateFormat;
